import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Ask the Assistant',
      type: 'metric',
      content: {
        '{}': {
          value: {
            '{}': {
              emphasis: 'Ask',
            },
          },
        },
      },
      // NOTE: a single, fixed action (no row context) that opens the
      // assistant slideout - the "direct"/static-payload counterpart to the
      // row-click-driven action on the 'goals-table' widget.
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              name: 'Open Assistant',
              action: {
                '{}': {
                  operation: 'ui.open-assistant',
                  payload: {
                    '{}': {
                      agentId: 'naming',
                      records: {
                        '[]': [],
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
}
